import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

export const JoinMightyCommunityBannerBackgroundContainer = styled.div`
  background-color: ${palette.spruce};
  max-width: 100vw;
`;

export const JoinMightyCommunityBannerContainer = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 620px;
  grid-column-gap: 4.3rem;
  min-height: 570px;

  @media screen and (max-width: ${layout.lg}) {
    grid-template-columns: 1fr 430px;
    min-height: 480px;
    grid-column-gap: 2rem;
  }

  @media screen and (max-width: ${layout.subMd}) {
    min-height: unset;
    grid-template-columns: 1fr;
  }
`;

export const LinkWrapper = styled.div`
  margin-top: 0.5rem;
  justify-self: start;

  > a {
    padding: 0.5rem 3rem;
    font-weight: 700;
  }

  @media all and (max-width: ${layout.subMd}) {
    justify-self: stretch;
    display: grid;

    > a {
      padding: 0.5rem 3rem;
    }
  }
`;

export const TextBlock = styled.section`
  display: grid;
  grid-row-gap: 1rem;
  max-width: 530px;
  justify-self: end;
  align-self: center;
  padding: 4rem 0 4rem 1.5rem;
  height: fit-content;

  .styled-link-branded {
    width: fit-content;
    padding: 1rem 3rem;
    margin-top: 1rem;
  }

  @media screen and (max-width: ${layout.lg}) {
    padding: 2rem 0 2rem 1.5rem;
  }

  @media screen and (max-width: ${layout.subMd}) {
    padding: 4.8rem 1.2rem;
    justify-self: center;

    h1,
    p {
      text-align: center;
    }

    .styled-link-branded {
      width: 100%;
      max-width: 300px;
      margin: 1rem auto 0;
    }
  }
`;

export const ImageBlock = styled.section`
  width: 100%;
  height: 100%;
  display: grid;

  @media screen and (max-width: ${layout.subMd}) {
    display: none;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  align-self: center;
  justify-self: center;
  max-width: calc(100% - 4rem);
`;
